import React from 'react'
import './footer.css';

const Footer = () => {
    const currentYear = new Date().getFullYear(); // Get current year

    return (
        <div className="footer-container">
            <div className="container-fluid">
                <div className="title">
                    Copyright ©{currentYear} J&H tech Pty Ltd. All rights reserved.
                </div>
            </div>
        </div>
    );
};

export default Footer;


// WEBPACK FOOTER //
// ./src/component/footer/footer.js